import React from "react";

export default function Navbar() {
  return (
    <nav className="navbar navbar-default bg-dark">
      <div className="container-fluid">
        <div className="navbar-header">
          <a className="navbar-brand text-white">Covid19-Tracker</a>
        </div>
      </div>
    </nav>
  );
}
